import React          from 'react';
import box_0          from 'images/box_0.png';
import box_1          from 'images/box_1.png';
import box_2          from 'images/box_2.png';
import box_3          from 'images/box_3.png';
import box_4          from 'images/box_4.png';
import box_5          from 'images/box_5.png';
import box_6          from 'images/box_6.png';
import box_7          from 'images/box_7.png';
import box_8          from 'images/box_8.png';
import box_9          from 'images/box_9.png';
import box_10         from 'images/box_10.png';
import closedBox      from 'images/closedBox.png';
import { makeStyles } from "makeStyles";

const arr = [box_0,box_1,box_2,box_3,box_4,box_5,box_6,box_7,box_8,box_9,box_10,closedBox];

const useStyles = makeStyles()(
    () => ({
    hidden: {  
      top:      '-300vh',
      left:     '-300vw',
      position: 'fixed',
      height:   100,
      width:    100, 
      opacity:  0, 
    }
}))


const Hidden: React.FC = () => {

  const { classes } = useStyles();

  return (
        <>
            {
              arr.map((val, ind) => {
                return(
                  <div  
                    key       = { `images_${ val }_${ ind }???` }
                    className = { classes.hidden }
                    style     = {{ backgroundImage: `${ val})` }}
                  />
                )
              })
            }
        </>
  );
  
}

export default Hidden;

